/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainDriverCompanyTargetMilestoneProgressStatusEnum {
  'DriverCompanyTargetMilestoneProgressStatusProgress' = 'progress',
  'DriverCompanyTargetMilestoneProgressStatusCompleted' = 'completed',
  'DriverCompanyTargetMilestoneProgressStatusFailed' = 'failed',
}

export type DomainDriverCompanyTargetMilestoneProgressStatus = DomainDriverCompanyTargetMilestoneProgressStatusEnum